module.exports = __webpack_public_path__ + "img/f4.c2635b4.png";